export default __webpack_public_path__ + "static/media/lobbey4.611eeef7.jpg";